export enum RemainingValueType {
  DAYS = 'DAYS',
  MILEAGE = 'MILEAGE',
  OPERATING_HOURS = 'OPERATING_HOURS'
}
